
import Cookie from "js-cookie";
import { request } from "@/utils/api/legacyRequest";
import { FLUSH_DELTAS } from "@/store/quill/quillActions";
import {
  SET_REDIRECT,
  SET_CHALLENGE_DATA_LOADED,
  REQUEST_PROCESSED,
  SET_PROJECT_ANSWERS_LOADED,
  CLOSE_UPLOAD_LOGO,
  CLOSE_UPLOAD_BACKDROP,
  FINISH_REQUEST,
  SET_PAGE_NOT_FOUND,
} from "@/store/metadata/metadataActions";
import {
  API_PUT,
  API_PUT_POST_IMAGE,
} from "@/store/middleware/middlewareConstants";

// import {
//   fetchUserCompletedTopics,
//   fetchUserCompletedBuilders,
// } from '@/store/builderData/builderDataActions';
import { toast, toastI18n } from "@/components/common/Toast";


import {
  SET_TOPIC,
  SET_ANSWER,
  SET_ANSWERS,
  SET_PROJECT_ANSWERS,
  RESOLVE_CONFLICT,
  SET_BROWSE_ALL_PROJECTS,
  SET_FILTERED_PROJECTS,
  SET_FILTER,
  REMOVE_FILTER,
  CLEAR_FILTERS,
  UPDATE_CHALLENGE,
  SET_FILTER_QUERY,
} from "./projectProfileConstants";
import { BACKEND_URI } from "@/config";

// Project About

// Project Backdrop

export const settingProjectBackdrop = () => {
  return /*withTranslation(['translation.notification']) (*/ (dispatch) => {
    dispatch(toastI18n('success', 'ProjectBackdropUploaded'));
    dispatch({ type: CLOSE_UPLOAD_BACKDROP });
    dispatch({ type: FINISH_REQUEST });
  };
};

export const updateProjectBackdrop = (projectId, formData, callback) => {
  if (
    !formData.get("project_backdrop[backdrop]") ||
    formData.get("project_backdrop[backdrop]") === "undefined"
  ) {
    return /*withTranslation(['translation.notification']) (*/ (dispatch) => {
      dispatch(toastI18n('error', 'SelectAnImage'));
      dispatch({ type: FINISH_REQUEST });
    };
  }

  return {
    type: API_PUT_POST_IMAGE,
    payload: {
      url: `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
        }/api/v1/rebel/projects/${projectId}`,
      body: formData,
      success: settingProjectBackdrop,
      onSuccess: callback,
      token: Cookie.get("token"),
    },
  };
};

// Project Logo

export const settingProjectLogo = () => {
  return /*withTranslation(['translation.notification']) (*/ (dispatch) => {
    dispatch(toastI18n('success', 'ProjectLogoUploaded'));
    dispatch({ type: CLOSE_UPLOAD_LOGO });
    dispatch({ type: FINISH_REQUEST });
  };
};

export const updateProjectLogo = (projectId, formData, callback) => {
  if (
    !formData.get("project_logo[logo]") ||
    formData.get("project_logo[logo]") === "undefined"
  ) {
    return /*withTranslation(['translation.notification']) (*/ (dispatch) => {
      dispatch(toastI18n('error', 'SelectAnImage'));
      dispatch({ type: FINISH_REQUEST });
    };
  }

  return {
    type: API_PUT_POST_IMAGE,
    payload: {
      url: `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
        }/api/v1/rebel/projects/${projectId}`,
      body: formData,
      success: settingProjectLogo,
      onSuccess: callback,
      token: Cookie.get("token"),
    },
  };
};

// Project Description

// Project Kudos

// Project Notes

// Project Details
export const pageNotFound = () => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE_NOT_FOUND });
  };
};

// Topics

export function fetchProjectTopicAnswers(topicId) {
  return (dispatch) => {
    const token = Cookie.get("token");
    if (token) {
      const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
        }/api/v2/rebel/challenges/project-answers/${topicId}`;
      return new Promise((resolve, reject) => {
        request(url, token)
          .then((response) => {
            dispatch({ type: SET_PROJECT_ANSWERS, data: response.data });
            resolve();
          })
          .catch(() => reject());
      });
    }
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/public/challenges/project-answers/${topicId}`;
    return new Promise((resolve, reject) => {
      request(url)
        .then((response) => {
          dispatch({ type: SET_PROJECT_ANSWERS, data: response.data });
          resolve();
        })
        .catch(() => reject());
    });
  };
}

export function fetchTopicAnswersFromList(topicAnswersList) {
  return (dispatch) => {
    if (topicAnswersList.length) {
      dispatch(fetchProjectTopicAnswers(topicAnswersList.shift())).then(() => {
        dispatch(fetchTopicAnswersFromList(topicAnswersList));
      });
    }
  };
}

// Answers

export const setAnswers = (data) => ({
  type: SET_ANSWERS,
  data,
});

export function updateTopicAnswers(
  values,
  topicId,
  projectId,
  builderId,
  callback = () => { },
  redirectTo = null
) {
  return /*withTranslation(['translation.notification']) (*/ (dispatch) => {
    const answerPayload = {
      ops: [values && values[topicId] ? values[topicId] : null],
    };

    const token = Cookie.get("token");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/projects/${projectId}/foundry/builders/${builderId}/topics/${topicId}`;
    const payload = {
      answer: answerPayload,
    };

    return request(url, token, "PUT", payload)
      .then((response) => {
        dispatch({ type: FLUSH_DELTAS });
        // TODO add correct functionality for this section
        // if (answerPayload) {
        //   dispatch({
        //     type: SET_ANSWER,
        //     data: answerPayload,
        //   });
        // }
        dispatch({ type: SET_TOPIC, data: response?.data });
        dispatch(toastI18n('success', 'AnswerSaved'));
        dispatch({ type: REQUEST_PROCESSED });
        // redirect to overview
        if (redirectTo) {
          dispatch({ type: SET_REDIRECT, url: redirectTo });
        }
        if (typeof callback === "function") {
          callback(projectId, builderId, topicId);
        }
      })
      .catch((err) => console.error(err));
  };
}

export function syncAndResolveConflict() {
  return (dispatch, getState) => {
    getState().projectProfilev1.conflictingAnswers.forEach((a) =>
      dispatch({ type: SET_ANSWER, id: a.get("id"), data: a })
    );
    dispatch({ type: RESOLVE_CONFLICT });
  };
}

// Challenges

export const settingChallengeIntroComplete = (data) => ({
  type: UPDATE_CHALLENGE,
  data,
});

export const setChallengeIntroComplete = (challengeId) => ({
  type: API_PUT,
  payload: {
    url: `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/challenges/project-challenges/${challengeId}`,
    body: { project_challenge: { intro_viewed: true } },
    success: settingChallengeIntroComplete,
    onSuccess: null,
    token: Cookie.get("token"),
  },
});

export function publishChallenge(projectId, builderId, publishedFor, cb) {
  return /*withTranslation(['translation.notification']) (*/ (dispatch) => {
    dispatch(toast.hide());
    const token = Cookie.get("token");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/projects/${projectId}/foundry/builders/${builderId}`;

    // validate
    if (!publishedFor) {
      dispatch(toastI18n('error', 'SelectWhoCanView'));
      return;
    }

    const payload = {
      is_published: true,
      published_for: publishedFor,
    };
    request(url, token, "PUT", payload)
      .then((response) => {
        dispatch({ type: UPDATE_CHALLENGE, data: response.data });
        if (typeof cb === "function") {
          cb();
        }
      })
      .then(() => dispatch(toastI18n('success', 'SuccessfullyPublished')));
    // todo: error handling
    // .then(response => dispatch(setUserSettings(response.data)))
  };
}

export function fetchChallengeData() {
  return (dispatch) => {
    // const { user } = getState();
    // const jwt = user.get('jwt');
    Promise.all([
      // dispatch(fetchChallenges(jwt)),
      // dispatch(fetchTopics(jwt)),
      // dispatch(fetchUserCompletedBuilders()),
      // dispatch(fetchUserCompletedTopics())
    ]).then(() => dispatch({ type: SET_CHALLENGE_DATA_LOADED }));
    // dispatch(fetchAnswers()).then(() =>
    dispatch({ type: SET_PROJECT_ANSWERS_LOADED });
    // );
  };
}

// Team

// Filter

export function applyFilters() {
  return (dispatch, getState) => {
    const { projectProfilev1 } = getState();
    const { filters, allProjects } = projectProfilev1;
    const query = filters.get("query") || "";

    if (filters.get("industries").isEmpty() && !query) {
      return dispatch({
        type: SET_FILTERED_PROJECTS,
        filteredProjects: allProjects,
      });
    }

    let filteredProjects = allProjects;

    // industry filter
    if (!filters.get("industries").isEmpty()) {
      filteredProjects = filteredProjects.filter((p) =>
        filters.get("industries").includes(p.get("industry_id"))
      );
    }

    // search filter
    if (query) {
      const searchTerm = (query || "").toLowerCase();

      filteredProjects = filteredProjects.filter((p) => {
        const name = p.get("name").toLowerCase();
        return name.indexOf(searchTerm) >= 0;
      });
    }

    return dispatch({ type: SET_FILTERED_PROJECTS, filteredProjects });
  };
}

export function clearFilters() {
  return (dispatch) => {
    dispatch({ type: CLEAR_FILTERS });
    dispatch(applyFilters());
  };
}

export function setFilterQuery(value) {
  return (dispatch) => {
    dispatch({ type: SET_FILTER_QUERY, value });
    dispatch(applyFilters());
  };
}

export function setFilter(filterType, value) {
  return (dispatch, getState) => {
    const { filters } = getState().projectProfilev1;

    // if filter is already applied, remove it
    if (filters.get(filterType).includes(value)) {
      dispatch({ type: REMOVE_FILTER, filterType, value });
    } else {
      dispatch({ type: SET_FILTER, filterType, value });
    }

    dispatch(applyFilters());
  };
}

// Get all the projects

export const fetchAllProjects = (
  url = `${BACKEND_URI}/api/v1/public/projects`
) => {
  return (dispatch) => {
    request(url).then((response) => {
      dispatch({ type: SET_BROWSE_ALL_PROJECTS, data: response.data });
      dispatch(applyFilters());
    });
  };
};
